export const HOME = '/';
export const ABOUT = '/about';
export const CONTACTUS = '/contact';
export const PRODUCTS = '/products';
export const PRODUCT = '/product/:id';
export const CHECKOUT = '/checkout';
export const TERMSCONDITIONS = '/terms&conditions';
export const PRIVACYPOLICY = '/privacy&policy';
